<div class="dlg">

  <header class="dlg__header">
    <h2 class="dlg__title">{{ title }}</h2>
    <p class="dlg__subtitle">{{ message }}</p>
  </header>

  <footer class="dlg__footer">
    <button type="button" class="btn btn--ghost" (click)="dismiss()">
      {{ 'delivery-note.cancel_btn' | translate }}
    </button>
    <button type="button" class="btn btn--confirm" (click)="confirm()">
      {{ 'delivery-note.confirm_btn' | translate }}
    </button>
  </footer>

</div>
